export const API_URL = process.env.VUE_APP_SERVER_URI;
export const LAZY_URL = `https://www.lazylionsnft.com/api`;
